import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { setDoc, doc, getDoc, } from "firebase/firestore";
import { useParams } from "react-router-dom";
import Grid from '@mui/material/Grid';
import ConfessionCard from "../utilities/components/ConfessionCard"
import ConfessionCardSkelton from "../utilities/components/ConfessionCardSkelton"
import { db } from "../config/FirebaseConfig";


function DisplaySingleConfession({ isAuth }) {
  let navigate = useNavigate();

  const [post, setPost] = useState()
  const [isLoading, setIsLoading] = useState(true);

  let { id } = useParams();

  const getPost = async () => {

    const docRef = doc(db, 'posts', id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      console.log("uuuuu: ",docSnap.data())
        setPost(docSnap.data())
    } else {
        console.log("No document for count");
    }
  }

  useEffect(() => {
    getPost()
    setIsLoading(false)
  }, []);



  return (
    <Grid
    container
    spacing={0}
    //direction="column"
    alignItems="center"
    justifyContent="center"
    sx={{mb: 20}}>
        <Grid item xs={11} sm={9} md={6}>
            {!isLoading && post?
              <ConfessionCard
                text={post.text}
                date={post.date}
                name={post.author && post.author.name}
                isAuth={isAuth}
                likedByIds={post.likedBy}
                disLikedByIds={post.disLikedBy}
                post_id={post.id}
            />:
            <ConfessionCardSkelton/>
          }
        </Grid>
    </Grid>
  );
}

export default DisplaySingleConfession;
